import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardSide from '../CardDesignerCardSide';
import { getCardSideElementsConfiguration } from '../../helpers';

const propTypes = {
  className: PropTypes.string,
  cardRef: PropTypes.object.isRequired,
  cardSide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    card_template: PropTypes.shape({
      id: PropTypes.string,
      card_elements: PropTypes.array,
    }).isRequired,
  }).isRequired,
  selectedCardElementId: PropTypes.string,
  onCardElementSelect: PropTypes.func.isRequired,
  onCardElementUpdate: PropTypes.func.isRequired,
  onCardElementDelete: PropTypes.func,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CardDesignerCard = ({
  className,
  cardRef,
  cardSide,
  selectedCardElementId,
  onCardElementSelect,
  onCardElementUpdate,
  onCardElementDelete,
  onElementConfigurationChange,
}) => {
  const cardTemplate = cardSide.card_template;
  const elements = getCardSideElementsConfiguration(cardSide);
  const classes = classNames({
    'card-designer-card': true,
    [`orientation-${cardTemplate.orientation?.toLowerCase()}`]: true,
    [className]: !!className,
  });

  return (
    <div ref={cardRef} className={classes}>
      <CardDesignerCardSide
        elements={elements}
        cardRef={cardRef}
        cardTemplate={cardTemplate}
        selectedCardElementId={selectedCardElementId}
        onCardElementSelect={onCardElementSelect}
        onCardElementUpdate={onCardElementUpdate}
        onCardElementDelete={onCardElementDelete}
        onElementConfigurationChange={onElementConfigurationChange}
      />
    </div>
  );
};

CardDesignerCard.propTypes = propTypes;

export default CardDesignerCard;
